import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-disabled", "disabled"]
const _hoisted_2 = ["disabled"]

import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { computed, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultButton',
  props: {
  loading: {
    type: Boolean,
    required: false,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  type: {
    type: String as PropType<"primary" | "secondary" | "danger" | "text" | "text-danger" | "black">,
    required: true,
  },
  isFormSubmit: {
    type: Boolean,
    required: false,
    defaultValue: false,
  },
},
  emits: ["action"],
  setup(__props, { emit }) {

const props = __props;




const type = computed(() => {
  let c = "";

  switch (props.type) {
    case "primary":
      c = "bg-primary active:bg-blue-600 hover:bg-blue-600 border-primary text-white disabled:bg-blue-300 disabled:border-blue-300 px-3 focus:outline-black px-0";
      break;
    case "secondary":
      c = "bg-secondary active:bg-gray-700 hover:bg-gray-700 border-secondary text-white px-3 focus:outline-black px-0";
      break;
    case "danger":
      c = "bg-danger hover:bg-red-600 border-danger text-white px-3";
      break;
    case "text":
      c = "border-none py-2 h-6 text-blue-500 hover:underline focus:outline-black px-0";
      break;
    case "text-danger":
      c = "hover:underline border-none h-6 text-red-500 px-0 focus:outline-black px-0";
      break;
    case "black":
      c = "bg-black active:bg-play-green hover:bg-play-green text-white px-3 py-2 text-lg border-black hover:border-play-green";
      break;
  }

  return c;
});

async function action() {
  if (props.loading) return;
  return emit("action");
}

return (_ctx: any,_cache: any) => {
  return (props.isFormSubmit)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "submit",
        "aria-disabled": __props.disabled,
        disabled: __props.disabled,
        class: _normalizeClass([
      _unref(type),
      'text-white capitalize border rounded focus:outline-none focus:shadow-outline-purple font-normal transition duration-50 ease-in px-3 py-1.5 h-10 flex items-center whitespace-nowrap',
    ])
      }, [
        (props.loading)
          ? (_openBlock(), _createBlock(LoadingSpinner, {
              key: 0,
              type: props.type
            }, null, 8, ["type"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_1))
    : (_openBlock(), _createElementBlock("button", {
        key: 1,
        onClick: action,
        type: "button",
        disabled: __props.disabled,
        class: _normalizeClass([
      _unref(type),
      'capitalize border rounded focus:outline-none focus:shadow-outline-purple font-normal transition duration-50 ease-in py-1.5 h-10 flex items-center whitespace-nowrap',
    ])
      }, [
        (props.loading)
          ? (_openBlock(), _createBlock(LoadingSpinner, {
              key: 0,
              type: props.type
            }, null, 8, ["type"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 10, _hoisted_2))
}
}

})